import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { api } from '../lib/api';

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const sid = params.get('session_id');
  const psub = params.get('paypal_sub') || params.get('subscription_id');
  const [state, setState] = useState(cancelled ? 'cancelled' : 'checking');

  useEffect(() => {
    if (cancelled || (!sid && !psub)) return;
    let tries = 0;
    const url = psub ? `/paypal/status/${psub}` : `/payments/status/${sid}`;
    const tick = async () => {
      try {
        const { data } = await api.get(url);
        if (data.payment_status === 'paid') return setState('paid');
        if (['expired', 'failed'].includes(data.payment_status)) return setState('failed');
      } catch { /* keep polling */ }
      if (++tries < 8) setTimeout(tick, 2000); else setState('timeout');
    };
    tick();
  }, [sid, psub, cancelled]);

  const V = {
    checking: [Loader2, 'Confirming your payment…', 'This usually takes a few seconds.', 'animate-spin text-primary'],
    paid: [CheckCircle2, 'Team Plan is active', 'Thank you for funding free benefits navigation. Your team dashboard is now unlocked.', 'text-[#0F5132]'],
    failed: [XCircle, 'Payment did not complete', 'No charge was made. You can try again from Partner Mode.', 'text-[#991B1B]'],
    timeout: [Loader2, 'Still processing', 'Stripe is taking longer than usual. Refresh this page in a minute — your plan activates automatically once payment is confirmed.', 'text-[#663C00]'],
    cancelled: [XCircle, 'Checkout cancelled', 'No charge was made.', 'text-muted-foreground'],
  }[state];
  const Icon = V[0];
  return (
    <div className="max-w-lg mx-auto px-4 py-16">
      <Card className="p-8 bg-card text-center" data-testid={`payment-${state}`}>
        <Icon className={`w-12 h-12 mx-auto ${V[3]}`} />
        <h1 className="text-2xl font-bold mt-4" style={{fontFamily: 'Lexend'}}>{V[1]}</h1>
        <p className="text-muted-foreground mt-2">{V[2]}</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button asChild className="bg-primary text-primary-foreground" data-testid="payment-back"><Link to={state === 'paid' ? '/partner/team' : '/partner'}>{state === 'paid' ? 'Open team dashboard' : 'Back to Partner Mode'}</Link></Button>
        </div>
      </Card>
    </div>
  );
}
